import { Dialog, DialogContent } from '@/components/ui/dialog';
import { FC } from 'react';

interface Props {
  isOpen: boolean;
  setIsOpen: () => void;
}

const TutorialModal: FC<Props> = ({ isOpen, setIsOpen }) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="!w-[85vw] !max-w-none h-[70vh] md:h-auto max-h-[95vh] px-0">
        <div style={{ position: 'relative', paddingTop: '56.25%' }}>
          <iframe
            src="https://player.vimeo.com/video/1174588012?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1&amp;loop=1"
            title="Vimeo video player tutorial"
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              border: 0,
            }}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TutorialModal;
